// Use IconDropdown in AgGrid columnDefs as cellRenderer: IconDropdown
// Add props as below for the list of items to be displayed on the dropdown and the redirection path

// cellRendererParams: {
// list: [
//     { text: "", path: "" }
//   ]
// }

// On the redirected page, you can get the data of the selected grid from location.state

import { createPortal } from "react-dom";
import { MaterialIcon } from "@/common/components";
import { useNavigate } from "@/common/hooks";
import { useState, useRef, useEffect } from "@/common/hooks";

const IconDropdown = (props) => {
  const navigate = useNavigate();
  const buttonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });

  const handleClick = (e) => {
    if (e.path) {
      navigate(e.path, { state: props.data });
    } else if (e.click) {
      e.click(props.data);
    }
    setOpen(false);
    window.dispatchEvent(new CustomEvent("close-all-dropdowns"));
  };

  const toggleDropdown = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const isMobile = window.innerWidth <= 768;
      setPosition({
        top: isMobile ? rect.bottom - 5 : rect.bottom,
        left: isMobile ? rect.left - 145 : rect.left + 13,
      });
    }
    window.dispatchEvent(new CustomEvent("close-all-dropdowns"));
    setOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (buttonRef.current && !buttonRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    const handleCloseAll = () => {
      setOpen(false);
    };

    document.addEventListener("click", handleClickOutside);
    window.addEventListener("close-all-dropdowns", handleCloseAll);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      window.removeEventListener("close-all-dropdowns", handleCloseAll);
    };
  }, []);

  return (
    <div className="icon-dropdown mt-1" onClick={(e) => e.stopPropagation()}>
      <button
        ref={buttonRef}
        className="btn btn-primary dropdown-toggle p-0"
        type="button"
        onClick={toggleDropdown}
      >
        <MaterialIcon iconName="pending" iconClassName="icon" />
      </button>

      {open &&
        props.list &&
        createPortal(
          <div className="icon-dropdown">
            <ul
              className="dropdown-menu show"
              style={{
                position: "absolute",
                top: position.top + window.scrollY,
                left: position.left,
                width: position.width,
                zIndex: 2000,
                display: "block",
              }}
            >
              {props.list.map((item, index) => {
                if (item.hide) return null;

                return (
                  <li
                    key={index}
                    onClick={() => handleClick(item)}
                    className="py-2"
                  >
                    <span className="dropdown-item">{item.text}</span>
                  </li>
                );
              })}
            </ul>
          </div>,
          document.body
        )}
    </div>
  );
};

export default IconDropdown;
